<div class="h-full w-full flex flex-col border-box relative">
  <div class="lg:h-[6%] border-box w-full sm:h-[6.5%] md:h-[10%]">
    <app-header></app-header>
  </div>
  <div
    class="flex w-full border-box lg:h-[94%] sm:h-[93.5%] md:h-[90%] flex-grow max-w-full"
  >
 @if(user.user_type!==userRole.WEB_DYN){
    <div
      class="lg:w-[3.6%] flex-wrap flex h-full absolute sm:-left-[100%] lg:left-0 sm:top-0 lg:top-0 bg-[#0E1217] text-white sm:z-[1000] lg:static"
      [class.displaySidebar]="sidebarOpen"
      (appClickableDirective)="closeSidebar()"
    >
      <app-sidebar
        class="w-full h-full"
        (newItemEvent)="sidebar($event)"
      ></app-sidebar>
    </div>
  }
    <div
      class="flex-grow border-box h-full flex flex-col"
      (appClickableDirective)="closeSidebar()"
    >
      <div class="h-full w-full flex-col bg-[#151A20] flex main-content-div">
        <div class="h-fit w-full subheader">
          @if (!isViewAsCustomer && isDashboard) {
            <app-sub-header></app-sub-header>
          }
        </div>

        <div
          class="flex-grow parent-container overflow-auto max-w-full overflow-x-auto"
        >
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
